import { render, staticRenderFns } from "./AntragsbuchColumnSelect.vue?vue&type=template&id=87e03af6&scoped=true"
import script from "./AntragsbuchColumnSelect.vue?vue&type=script&lang=ts"
export * from "./AntragsbuchColumnSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87e03af6",
  null
  
)

export default component.exports